import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function SidebarLinks({ user }) {
  const location = useLocation();
  if (!user) return null;

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  const hasRole = (allowedRoles) => allowedRoles.includes(user?.role);

  // 📌 TABLEAU DES LIENS
  const links = [
    {
      label: "Dashboard",
      icon: "fa-home",
      path: "/admin-gest/home",
      roles: ["super_admin", "dev"],
    },

    // --- SUPER ADMIN & DEV ---
    {
      group: "Administration",
      role: ["super_admin", "dev"],
      items: [
        {
          label: "Utilisateurs",
          icon: "fa-users",
          path: "/admin-gest/utilisateurs",
          roles: ["super_admin", "dev"],
        },
        {
          label: "Rendez-vous",
          icon: "fa-calendar-check",
          path: "/admin-gest/rdvs",
          roles: ["super_admin", "dev"],
        },
        {
          label: "Galerie",
          icon: "fa-images",
          path: "/admin-gest/galeries",
          roles: ["super_admin", "dev"],
        },
        {
          label: "Posts",
          icon: "fa-newspaper",
          path: "/admin-gest/post",
          roles: ["super_admin", "dev"],
        },
        {
          label: "Commandes",
          icon: "fa-shopping-cart",
          path: "/admin-gest/commandes",
          roles: ["super_admin", "dev"],
        },
      ],
    },

    // ----------- CONTENU DU SITE -----------
    {
      group: "Contenu du site",
      role: ["super_admin", "dev", "staff"],
      items: [
        {
          label: "Pages",
          icon: "fa-file",
          path: "/admin-gest/pages",
          roles: ["super_admin", "dev", "staff"],
        },
        {
          label: "Infos Générales",
          icon: "fa-cog",
          path: "/admin-gest/settings",
          roles: ["super_admin", "dev"],
          multiline: true,
        },
      ],
    },
  ];

  return (
    <div className="navbar-nav w-100">
      {/* ➤ Lien Dashboard (hors groupes) */}
      <Link
        to="/admin-gest/home"
        className={`nav-item nav-link ${
          isActive("/admin-gest/home") ? "active bg-body-secondary fw-bold" : ""
        }`}
      >
        <i className="fa fa-home me-2"></i>
        <span className="text-body">Dashboard</span>
      </Link>

      {/* ➤ Boucle sur les groupes */}
      {links
        .filter((g) => g.group) // ignore l’entrée Dashboard
        .map((group, idx) => (
          <div key={idx}>
            {hasRole(group.role) && (
              <>
                <hr />
                <h6 className="text-uppercase text-muted ps-3 mt-3">
                  {group.group}
                </h6>
              </>
            )}

            {group.items
              .filter((item) => hasRole(item.roles))
              .map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  className={`nav-link d-flex align-items-center ${
                    isActive(item.path)
                      ? "active bg-body-secondary fw-bold"
                      : ""
                  }`}
                >
                  <i className={`fa ${item.icon} me-2`}></i>

                  <span className="text-body">
                    {item.multiline ? (
                      <>
                        Infos <br /> Générales
                      </>
                    ) : (
                      item.label
                    )}
                  </span>
                </Link>
              ))}
          </div>
        ))}
    </div>
  );
}
